import { Subscription } from "@/types/entities";
import { Styled } from "./styles";
import { Typography } from "@mui/material";

const pricing = {
    mini: "120",
    basic: "250",
    professional: "400",
    enterprise: "750",
};

interface Props {
    subscription?: Subscription;
}

const SubscriptionComponent: React.FC<Props> = ({ subscription }) => {
    if (!subscription) return null;

    const { plan, usage } = subscription;

    return (
        <Styled.Box>
            <Typography variant="h3">Subscription</Typography>
            <Typography variant="body2" gap={1} display="flex" alignItems="center">
                Current active subscription:{" "}
                <Styled.Span
                    data-testid="settings-subscription-plan"
                    component="span"
                    sx={{ textTransform: "capitalize" }}
                >
                    {plan}
                </Styled.Span>
            </Typography>
            {plan === "free" ? null : (
                <Typography variant="body2" gap={1} display="flex" alignItems="center">
                    Price:{" "}
                    <Styled.Span component="span">
                        {plan === "custom" ? "Custom pricing" : `€ ${pricing[plan]} Yearly + VAT`}
                    </Styled.Span>
                </Typography>
            )}
            {usage.labels.available ? (
                <Typography variant="body2" gap={1} display="flex" alignItems="center">
                    Available digital labels:{" "}
                    <Styled.Span component="span">{usage.labels.available}</Styled.Span>
                </Typography>
            ) : null}
            {usage.labels.used ? (
                <Typography variant="body2" gap={1} display="flex" alignItems="center">
                    Used digital labels:{" "}
                    <Styled.Span component="span">{usage.labels.used}</Styled.Span>
                </Typography>
            ) : null}
        </Styled.Box>
    );
};

export default SubscriptionComponent;
